<template>
  <div class="profile-steps">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 cus-step-wrap"
      >
        <div class="flex_content mb-4">
          <!-- <h1 class="section_header m-0">Industry Market Profile</h1>-->
          <ProgressBar :scale="progress" v-if="$route.query['data-id']" />
        </div>
        <div class="step-progress__wrapper">
          <div class="step-progress__bar md-layout">
            <div
              class="md-medium-size-50 md-layout-item md-xsmall-size-100 custom-step-pro p-0"
            >
              <div
                id="industryDiv"
                class="step-progress__step step-progress__step--valid"
                @click="selectedTab($event)"
              >
                <span class="step">1</span>
                <div class="step-progress__step-icon fa fa-check"></div>
                <div class="step-progress__step-label">
                  <div class="arrow-up"></div>
                  Industry
                </div>
                <div class="step-progress__step-sub-label">
                  <div class="progress-step-actions">
                    <div
                      class="action-text industry"
                      @click="
                        getData(industry)
                          ? resetIndustry($event)
                          : openSelector($event)
                      "
                    >
                      {{
                        getData(industry)
                          ? getData(industry)
                          : "Select Industry"
                      }}
                      <md-icon v-if="industry != null" class="action-icon"
                        >replay</md-icon
                      >
                    </div>
                    <div class="favourite black-color" v-if="industry != null">
                      <md-icon
                        @click.native="favoriteIndustry"
                        v-if="industry != null"
                        class="action-icon"
                        >star_border </md-icon
                      >Add to Favorites
                    </div>
                  </div>
                </div>
                <div class="dropdownMenu">
                  <nav-tabs-card no-label md-elevation="0">
                    <template slot="content">
                      <md-tabs md-alignment="left" id="financialProfileTabs">
                        <industry-tab />
                      </md-tabs>
                    </template>
                  </nav-tabs-card>
                </div>
              </div>
              <div
                id="industryFavoriteDiv"
                :class="
                  this.isRetail
                    ? 'non-subscriber favourite_list'
                    : 'favourite_list'
                "
                @click="isRetail ? {} : favorites($event)"
              >
                <md-tooltip
                  v-if="this.isRetail"
                  md-direction="right"
                  class="width-tooltip"
                  >Upgrade to a subscription to access this feature</md-tooltip
                >
                <i class="md-icon">star</i>Favorite Industries
                <div class="dropdownMenu">
                  <sidebar-search tab="industry" title="Favorite Industries" />
                </div>
                <div id="industry_notify" class="notify">
                  Successfully Added to Favorite
                </div>
              </div>
            </div>
            <div
              class="md-medium-size-50 md-layout-item md-xsmall-size-100 custom-step-pro p-0"
            >
              <div
                id="marketDiv"
                class="step-progress__step step-progress__step--valid"
                @click="selectedTab($event)"
              >
                <span class="step">2</span>
                <div class="step-progress__step-icon fa fa-check"></div>

                <div class="pl-0 pb-0 md-layout step-progress__step-label">
                  <div class="arrow-up"></div>
                  <div
                    class="pl-0 md-layout-item md-medium-size-30 md-xsmall-size-30 md-size-30"
                  >
                    Market Area
                  </div>
                  <div
                    class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40 div-radius-button"
                  >
                    <md-button
                      :class="checkRadius()?'md-info md-block enter-radius-button': 'md-info md-block enter-radius-button unavailable'"
                      @click="setModalRadius"
                    >
                      Enter Radius
                    </md-button>
                  </div>
                </div>
                <div class="step-progress__step-sub-label">
                  <div class="progress-step-actions">
                    <div
                      class="action-text area"
                      @click="
                        getTitle(marketArea)
                          ? resetMarket($event)
                          : openSelector($event)
                      "
                    >
                      {{
                        getTitle(marketArea)
                          ? getTitle(marketArea)
                          : "Select Market"
                      }}
                      <md-icon v-if="marketArea != null" class="action-icon"
                        >replay</md-icon
                      >
                    </div>
                    <div
                      class="favourite black-color"
                      v-if="marketArea != null"
                    >
                      <md-icon
                        @click.native="favoriteMarket"
                        v-if="marketArea != null"
                        class="action-icon"
                        >star_border </md-icon
                      >Add to Favorite
                    </div>
                  </div>
                </div>
                <div class="dropdownMenu">
                  <nav-tabs-card no-label md-elevation="0">
                    <template slot="content">
                      <md-tabs md-alignment="left" id="financialProfileTabs">
                        <market-area-tab />
                      </md-tabs>
                    </template>
                  </nav-tabs-card>
                </div>
              </div>
              <div
                id="areasFavoriteDiv"
                :class="
                  this.isRetail
                    ? 'non-subscriber favourite_list'
                    : 'favourite_list'
                "
                @click="isRetail ? {} : favorites($event)"
              >
                <md-tooltip
                  v-if="this.isRetail"
                  md-direction="right"
                  class="width-tooltip"
                  >Upgrade to a subscription to access this feature</md-tooltip
                >
                <i class="md-icon">star</i>Favorite Market Areas
                <div class="dropdownMenu">
                  <sidebar-search
                    tab="market_area"
                    title="Favorite Market Areas"
                  />
                </div>
                <div id="market_notify" class="notify">
                  Successfully Added to Favorite
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal v-if="classicModal" @close="classicModal = false">
      <template slot="header">
        <h4 class="modal-title">Industry Profile Version</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="classicModal = false"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <p>
          This is where we will explain the difference between a regular IF
          profile and a SPIF profile.
        </p>
      </template>

      <template slot="footer">
        <md-button class="md-simple">Nice Button</md-button>
        <md-button class="md-danger md-simple" @click="classicModal = false"
          >Close</md-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal, ProgressBar } from "@/components";
import axios from "axios";
import { NavTabsCard } from "@/components";
import IndustryTab from "../_market_partials/IndustryTab";
import MarketAreaTab from "../_market_partials/MarketAreaTab";
import SidebarSearch from "./SidebarSearch";
import { mapActions, mapState } from "vuex";

export default {
  name: "profile-steps",
  components: {
    Modal,
    NavTabsCard,
    IndustryTab,
    MarketAreaTab,
    SidebarSearch,
    ProgressBar,
  },
  data() {
    return {
      radio: false,
      classicModal: false,
      progress: 70,
      route: null,
    };
  },

  methods: {
    ...mapActions({
      updatePullTime: "tracking/updatePullTime",
    }),
    checkRadius: function(){
      if(this.$store.getters['user/userAccess'])
        if(this.$store.getters['user/userAccess'].impAccess.geo_radius)
          return true;
        else
          return false;
      else
        return true;
    },
    openSelector(event) {
      let selectorDiv = null;

      if (event.target.classList.contains("industry"))
        selectorDiv = document.getElementById("industryDiv");
      else if (event.target.classList.contains("area"))
        selectorDiv = document.getElementById("marketDiv");

      if (selectorDiv.classList.contains("open"))
        selectorDiv.classList.remove("open");
      else selectorDiv.classList.add("open");
    },
    setModalRadius() {
      this.$store.commit("M_SET_MODAL_MARKET_RADIUS", true);
    },
    getData: function(name) {
      if (name) {
        this.updatePullTime({
          isFinishedDate: false,
          productId: this.profileId,
        });
        return name.split("[")[1].split("]")[0];
      }
    },
    getTitle: function(name) {
      if (name) {
        return name.split("[")[0];
      }
    },
    favoriteIndustry: async function() {
      let notify = document.getElementById("industry_notify");
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      const industryData = this.getData(this.industry);

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + "/user/favorites/add",
          {},
          {
            params: {
              session_id: currentSession,
              category1: "universal",
              category2: "industry",
              data: industryData,
              search1: this.industry,
              search2: industryData,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/add" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.$store.commit("M_PUSH_TO_FAVORITE_INDUSTRIES", {
            data: industryData,
            search1: this.industry,
            id: res.data.favorite_id,
          });
          notify.classList.add("show");
          setTimeout(function() {
            notify.classList.remove("show");
          }, 3000);
        });
    },
    favoriteMarket: async function() {
      let notify = document.getElementById("market_notify");
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      const marketData = this.getData(this.marketArea);

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + "/user/favorites/add",
          {},
          {
            params: {
              session_id: currentSession,
              category1: "universal",
              category2: "market_area",
              data: marketData,
              search1: this.marketArea,
              search2: marketData,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/adds" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.$store.commit("M_PUSH_TO_FAVORITE_MARKET_AREAS", {
            data: marketData,
            search1: this.marketArea,
            id: res.data.favorite_id,
          });
          notify.classList.add("show");
          setTimeout(function() {
            notify.classList.remove("show");
          }, 3000);
        });
    },
    resetIndustry: async function() {
      this.$store.commit("M_SET_INDUSTRY", null);
      this.$store.commit("M_SET_SEARCH_INDUSTRIES", null);
      this.$store.commit("M_SET_SEARCH_LOADING_INDUSTRY", false);
      this.progress;

      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              industry: "0",
              profile_id: this.profileId ? this.profileId : "0",
              type: "imr",
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit("M_SET_PROFILE_ID", id);
        });
    },
    resetMarket: async function() {
      this.$store.commit("M_SET_MARKET_AREA", null);
      this.progress;

      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              area: 0,
              profile_id: this.profileId ? this.profileId : "0",
              type: "imr",
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit("M_SET_PROFILE_ID", id);
        });
    },
    toArray: function(arrLike) {
      return [].slice.call(arrLike);
    },
    setMarketClass: function() {
      if (
        this.marketArea != null ||
        (this.marketAreaRadius != null &&
          this.marketAreaCenter != null &&
          this.marketAreaCenterZip != null)
      ) {
        document
          .querySelector("#marketDiv")
          .classList.remove("step-progress__step--valid");
        document
          .querySelector("#marketDiv")
          .classList.add("step-progress__step--active");
      } else {
        document
          .querySelector("#marketDiv")
          .classList.remove("step-progress__step--active");
        document
          .querySelector("#marketDiv")
          .classList.add("step-progress__step--valid");
      }
    },

    setIndustryClass: function() {
      // if (this.$store.getters.industry != null) {
      if (this.industry != null) {
        document
          .querySelector("#industryDiv")
          .classList.remove("step-progress__step--valid");
        document
          .querySelector("#industryDiv")
          .classList.add("step-progress__step--active");
      } else {
        document
          .querySelector("#industryDiv")
          .classList.remove("step-progress__step--active");
        document
          .querySelector("#industryDiv")
          .classList.add("step-progress__step--valid");
      }
    },
    favorites: function(e) {
      let activeClass = e.target;
      this.validateClickOutside(activeClass);
      if (activeClass.classList.contains("open")) {
        activeClass.classList.remove("open");
      } else {
        activeClass.classList.add("open");
      }
    },
    selectedTab: function(e) {
      let activeClass = e.target.parentElement;

      if (activeClass) {
        if (activeClass.classList.contains("open")) {
          activeClass.classList.remove("open");
          this.validateClickOutside(activeClass);
          e.stopPropagation();
        } else {
          this.validateClickOutside(activeClass);
          e.stopPropagation();
          let elems2 = document.querySelector(".progress-step-actions");

          [].forEach.call(elems2, function(el) {
            el.classList.remove("open");
          });

          activeClass.classList.add("open");
          // activeClass.nextElementSibling.classList.remove('open');
        }
        let elems = this.toArray(
          document.querySelectorAll(".md-tab-nav-button")
        );

        elems.forEach(function(el) {
          el.classList.remove("md-active");
        });

        let currentTab = parseInt(e.currentTarget.firstElementChild.innerText);
        document
          .querySelectorAll(".md-tab-nav-button")
          [currentTab - 1].classList.add("md-active");
        // switch (currentTab) {
        //   case 1:
        //     document
        //       .querySelector('.md-tabs-container')
        //       .setAttribute('style', 'transform: translate3d(0%, 0px, 0px)');
        //     break;
        //   case 2:
        //     document
        //       .querySelector('.md-tabs-container')
        //       .setAttribute('style', 'transform: translate3d(-100%, 0px, 0px)');
        //     break;
        //   case 3:
        //     document
        //       .querySelector('.md-tabs-container')
        //       .setAttribute('style', 'transform: translate3d(-200%, 0px, 0px)');
        //     break;
        // }
      }
    },
    saveProfile: async function() {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : "0",
              industry: this.getData(this.industry),
              area: this.getData(this.marketArea),
              type: "imr",
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit("SET_PROFILE_ID", id);
        });
    },
    validateClickOutside: function(activeClass) {
      let openClass = document.getElementsByClassName("open");
      if (openClass)
        [].forEach.call(openClass, function(el) {
          if (activeClass.id) el.classList.remove("open");
        });
    },
  },
  computed: {
    ...mapState({
      isRetail: (state) =>
        state.user.user_type.retail/* || state.user.allow_retail*/ ? true : null,
    }),
    profileId() {
      return this.$store.getters.mProfileId;
    },
    industry() {
      return this.$store.getters.mIndustry;
    },
    marketArea() {
      return this.$store.getters.mMarketArea;
    },
    marketAreaCenterZip() {
      return this.$store.getters.mSearchMarketCenterZip;
    },
    marketAreaCenter() {
      return this.$store.getters.mSearchMarketCenter;
    },
    marketAreaRadius() {
      return this.$store.getters.mSearchMarketRadius;
    },
  },
  mounted() {
    if (this.$route.name === "NewMarketProfile")
      this.route = "/user/search_profiles/imr";
    else this.route = "/user/search_reports/imr";

    this.setIndustryClass();
    this.setMarketClass();
  },
  watch: {
    industry(newValue, oldValue) {
      this.setIndustryClass();
      if (newValue) {
        this.progress += 15;
      }
      if (oldValue) {
        this.progress -= 15;
      }
    },
    marketArea(newValue, oldValue) {
      this.setMarketClass();
      if (newValue) {
        this.progress += 15;
      }
      if (oldValue) {
        this.progress -= 15;
      }
    },
    marketAreaCenterZip() {
      this.setMarketClass();
    },
    marketAreaCenter() {
      this.setMarketClass();
    },
    marketAreaRadius() {
      this.setMarketClass();
    },
  },
};
</script>
<style lang="scss" scoped>
.info-btn-custom {
  background-color: white !important;

  &:hover {
    background-color: white !important;
    box-shadow: none;
  }
}

.step-progress__step:hover {
  cursor: pointer;
}

.action-text {
  opacity: 1 !important;
  transform: unset !important;
  font-size: 14px !important;
}

.custom-step-pro::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  height: 2px;
  width: 96%;
  background-color: grey;
  z-index: -1;
}

.custom-step-pro:last-child::before {
  content: none;
}

@media screen and (max-width: 1280px) and (min-width: 600px) {
  .custom-step-pro:nth-child(4),
  .custom-step-pro:nth-child(5) {
    margin-top: 130px;
  }

  .custom-step-pro:nth-child(3)::before {
    content: none;
  }

  .cus-step-wrap {
    padding-top: 20px;
  }

  .step-progress__step:after {
    width: 30px !important;
    height: 30px !important;
  }

  .step-progress__step span {
    font-size: 18px;
  }

  .step-progress__step-icon {
    font-size: 12px !important;
  }
}

@media only screen and (max-width: 600px) {
  .custom-step-pro::before {
    left: -6%;
    top: 369%;
    width: 27%;
    transform: rotate(90deg);
  }

  .custom-step-pro {
    margin-bottom: 80px;
  }

  .step-progress__step-label .arrow-up {
    display: none;
  }

  .step-progress__step:after {
    left: 8%;
    top: 150%;
  }

  .step-progress__step-icon {
    left: 8%;
    top: 150%;
  }

  .step-progress__step-label {
    top: 0;
    left: 63%;
  }

  .custom-step-pro:nth-child(4),
  .custom-step-pro:nth-child(5) {
    margin-top: unset;
  }

  .step-progress__step:after {
    width: 30px !important;
    height: 30px !important;
  }

  .step-progress__step span {
    font-size: 18px;
  }

  .step-progress__step-icon {
    font-size: 12px !important;
  }

  .cus-step-wrap {
    padding-top: 20px;
  }
}

.md-button.md-block.enter-radius-button {
  width: 90% !important;
  border-radius: 80px !important;
}

.div-radius-button {
  text-align: right;
}
</style>
